import { FunctionBrick, registerBrick } from 'olympe';

export default class SetLocalStorage extends FunctionBrick {

    /**
     * Executed every time an input (key, value) gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {string} key
     * @param {string} value
     * @param {!Array} outputs
     */
    onUpdate(context, [key, value], outputs) {
        // Making sure the browser support local storage
        if (typeof Storage !== 'undefined') {
            localStorage.setItem(key, value);
        } else {
            throw new Error(`Your browser does not support the window.localStorage API`);
        }
    }
}

registerBrick('017a4327a3e9746c361d', SetLocalStorage);
